import { render, staticRenderFns } from "./OrderConfirmationHotelReservationInfo.vue?vue&type=template&id=2dd83d8c&"
import script from "./OrderConfirmationHotelReservationInfo.vue?vue&type=script&lang=js&"
export * from "./OrderConfirmationHotelReservationInfo.vue?vue&type=script&lang=js&"
import style0 from "./OrderConfirmationHotelReservationInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports